var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":true,"value":_vm.overlay,"z-index":"100"}},[_c('div',{attrs:{"id":"loadingHolder"}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }